/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
// import challan_style from './challan-print/challan-style';
import Portal from 'components/base/Portal';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import fetchData from 'services/fetchData';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import dayjs from 'dayjs';
import PageLoader from 'components/custom/animate-component/PageLoader';
import kerpLogo from 'assets/img/logos/challan_logo_img.jpeg';
import challan_style from 'views/operation/Challan/challan-print/challan-style';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { currencyFormat } from 'helpers/utils';
import { useAlert } from 'providers/AlertModalProvider';
import { formatDate } from 'services/utils';

const PaymentSettlementPrint = ({ id, handleLoading, data }) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printData, setPrintData] = useState(false);
  console.log('🚀 ~ printData:', printData);
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const challanId = id;

  const fetchRequest = async () => {
    setLoading(true);

    const getSettlementData = await fetchData(
      apiEndpoints.trucker.getSettlementDataById(data.settlement_id)
    );

    console.log(
      '🚀 ~ fetchRequest ~ getSettlementData.status:',
      getSettlementData.data
    );
    if (getSettlementData.status) {
      // handleLoading(false, '');
      const settlementData = {
        trucker_id: getSettlementData.data.trucker_id,
        tds_percent: getSettlementData.data.tds_percent,
        challans: getSettlementData.data.challans,
        totalChallanAmount: getSettlementData.data.final_total_amount,
        totalTdsCharges: getSettlementData.data.total_tds_charges,
        settelment_no: getSettlementData.data.settelment_no,
        settlement_date: getSettlementData.data.settelment_date,
        settlement_status: getSettlementData.data.status,

        created_by_name: getSettlementData.data.created_by_name,
        checker_by_name: getSettlementData.data.checker_by_name,
        approved_by_name: getSettlementData.data.approved_by_name,
        paid_by_name: getSettlementData.data.paid_by_name,

        truckerInformation: {
          truckerName: getSettlementData.data.trucker_name,
          contactNo: getSettlementData.data.trucker_phone,
          panNo: getSettlementData.data.pan_no,
          bankName: getSettlementData.data.trucker_bank_name,
          bankAccountNo: getSettlementData.data.trucker_account_number,
          ifscCode: getSettlementData.data.trucker_bank_ifsc
        }
      };
      console.log('🚀 ~ fetchRequest ~ settlementData:', settlementData);
      setPrintData(settlementData);
      setIsPrinting(true);
      setTimeout(() => {
        setLoading(false);
      }, 200);
    } else {
      handleLoading(false, '');
      showAlert({
        variant: 'danger',
        message: 'Failed to fetch settlement data'
      });
    }
    // const response = await fetchData(apiEndpoints.challan.getChallanPrint(id));

    // if (response.status) {
    //   const fetchedData = response.data;
    //   setPrintData(data);
    //   setIsPrinting(true);
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 200);
    // } else {
    //   setLoading(false);
    // }
  };

  return (
    <>
      <Button
        onClick={fetchRequest}
        startIcon={<Icon className="fs-9" icon={'lets-icons:print-light'} />}
        variant={`phoenix-primary`}
        className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
      >
        Print
      </Button>

      {isPrinting && !loading && (
        <SettlementPrint
          printData={printData}
          onComplete={() => setIsPrinting(false)}
        />
      )}
    </>
  );
};

const SettlementPrint = ({ onComplete = () => {}, printData }) => {
  console.log(printData, 'printDataprintData');
  const barCodeRef = useRef(null);

  useEffect(() => {
    // Generate barcode when component mounts
    if (barCodeRef.current) {
      JsBarcode(barCodeRef.current, 123, {
        width: 2,
        height: 30,
        displayValue: false
      });
    }
  }, []);

  function printLR(labels) {
    const challan = document.getElementById('challan');

    var popupWin = window.open('', '_blank');
    if (popupWin?.document) {
      popupWin.document.open();
      popupWin.document.write(
        `<html>
        <head>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/css/bootstrap.min.css"
          />
          <style>${challan_style}</style>
          <style>
            @page { size: 210mm 297mm; margin: 0; padding: 0; }
            @media print { 

            .pageNumber:after {
              counter-increment: page;
              content: counter(page);
            }

            body {
              counter-reset: page;
            }

                  .print-meta {
              display: flex;
              justify-content: space-between;
              margin: 1rem;
            }
              @page { size: 210mm 297mm; }
              table, td, tr { padding: 7px !important; line-height: 20px !important; font-size: 18px !important; }
               .thead-bg th {
            padding-top: 16px !important;  /* Increase top padding */
            padding-bottom: 16px !important; /* Increase bottom padding */
            }
            }
          </style>
        </head>
        <style type="text/css">
          @media print {
            .hide-on-print {
              display: none;
            }

            
            body {
              background-color: white !important;
              // margin-top: 500mm;
              padding: 15px;
               counter-reset: page;
            }

            * {
              font-size: 97% !important;
              font-family: Arial !important;
            }

            @page {
              margin: 5px;
              margin-top: 5mm;
            }

            .container {
              width: -webkit-fill-available;
            }

            #title_tag {
              background-color: #ddd !important;
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
          }

          @media (min-width: 1200px) {
            .container {
              max-width: 1200px;
            }
          }

          table,
          td,
          th {
            border: 1px solid #c7c7c7;
            padding: 7px !important;
            line-height: 15px !important;
          }

          #title_tag {
            font-size: 100% !important;
            background-color: #ddd;
            color: black;
            text-align: center;
          }

          #element_tag {
            font-size: 100% !important;
            color: black;
            text-align: left;
          }

          .word-wrap {
            word-break: break-all;
          }

          .LR {
            page-break-inside: avoid;
          }
        #container1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 1rem;
  gap: 20px; /* Space between left and right content */
}

.left-content {
  width: 60%; /* Increase width for better balance */
  font-size: 18px; /* Increase text size */
}


  .right-content {
  width: 70%;
  margin-left: auto; /* Pushes the table to the right */
  display: flex;
  justify-content: flex-end; /* Aligns table to the right */
}
.netPay{
font-size: 30px !important;
}
.paragraph {
  display: flex;
  gap: 8px;
margin-top: 0.7rem;
  font-size: 22px !important; /* Increase text size */
}
.paragraph strong {
  white-space: nowrap; /* Keep label and value in one line */
}
.info-table {
  width: 60%; /* Decreases table width */
  border-collapse: collapse;
  text-align: left;
}

.info-table td {
  padding: 5px;
  border: 1px solid #ccc;
  font-size: 16px;
}

.info-table td:first-child {
  font-weight: bold;
  width: 50%;
}


            .tableMargin{
            margin-top: 2rem;
            }

             #amount-container {
            display: flex;
            justify-content: space-between;
            margin-top: 1rem;
            align-items: center;
            font-size: 20px !important; 
          }
          .bold-text {
            font-weight: bold;
          }
            .bank-detail{
            font-weight: bold;
             font-size: 20px !important; 
            }
             .bank-detail-heading{
             margin-top: 1.8rem;
             }

             .bank-detail-mt{
             margin-top: 0.7rem;
             }
          .blue-text {
            font-size: 0.9rem; /* Equivalent to Bootstrap 'fs-9' */
          }
        .bold-sub{
         font-weight: bold;
             font-size: 19px !important; 
        }
          .bold-sub-detail{
             font-size: 19px !important; 
          }
          .heading {
            font-weight: bold;
            font-size: 3rem; /* Equivalent to Bootstrap 'h4' */
          }
             #info-container {
            display: flex;
            justify-content: space-between;
            margin-top: 2.3rem;
          }
          .info-block {
            text-align: center;
          }
          .info-block strong {
            display: block;
            font-weight: bold;
            margin-bottom: 0.3rem;
          }
          .info-block p {
            margin: 0;
          }

          .thead-bg {
            background-color: #f8f9fa; !important/* Change to your desired background color */
            }    
//             th {
//   white-space: nowrap;
// }
        </style>
        <body onload="window.print()" style="margin: 0;">`
      );

      popupWin.document.write(challan?.innerHTML);

      const style = popupWin.document.createElement('style');
      style.media = 'print';

      const pageSize = 'Landscape';

      style.appendChild(
        popupWin.document.createTextNode(`@page { size: ${pageSize}; }`)
      );

      if (pageSize === 'Portrait') {
        style.appendChild(
          popupWin.document.createTextNode(
            'table,td,tr { padding: 2px 7px !important; }'
          )
        );
      } else {
        style.appendChild(
          popupWin.document.createTextNode(
            'table,td,tr { padding: 7px !important; line-height: 20px !important; font-size: 18px !important; }'
          )
        );
      }

      popupWin.document.head.appendChild(style);

      const title =
        labels.length === 1 ? `C2024/09/1282 ${labels[0]}` : 'C2024/09/1282 LR';
      popupWin.document.title = printData.settelment_no;

      popupWin.document.write('</html>');
      popupWin.document.close();
      popupWin.onload = () => {
        popupWin.print({
          header: true,
          footer: false
        });
        setTimeout(() => {
          popupWin.close();
        }, 1000); // Adjust the delay as needed
      };
    }
    onComplete();
  }

  // On single click download all lr copies
  function downloadConsignerConsigneeAckCopies() {
    printLR(['Consigner Copy', 'Transporter Copy']);
  }

  useEffect(() => {
    setTimeout(downloadConsignerConsigneeAckCopies, 300);
  }, [downloadConsignerConsigneeAckCopies]);

  const fetchDatas = [
    {
      challanDate: 'Jan 14,2025',
      challanNo: 'CH12345',
      vehicleNo: 'MH12AB1234',
      rate: 1500,
      disQty: 500,
      recQty: 480,
      minQty: 20,
      freightAmt: 5000,
      fuelLtr: 12,

      fuelAmt: 1200,
      cashAdvance: 3000,
      loadingExpenses: 800,
      penaltyCharges: 200,
      totalDeductions: 500,
      balanceAmt: 2500,
      netFreight: 23,
      shortAmt: 25,
      shortQty: 24
    },
    {
      challanDate: 'Mar 12,2025',
      challanNo: 'CH67890',
      vehicleNo: 'MH14XY5678',
      rate: 1800,
      disQty: 600,
      recQty: 590,
      minQty: 10,
      freightAmt: 6000,
      fuelLtr: 10,
      fuelAmt: 1500,
      cashAdvance: 3500,
      loadingExpenses: 900,
      penaltyCharges: 300,
      totalDeductions: 700,
      balanceAmt: 2800,
      netFreight: 13,
      shortAmt: 15,
      shortQty: 14
    }
  ];

  // Calculate totals
  const totalDisQty = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.dispatch_quantity || 0),
    0
  );
  const totalRecQty = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.receive_quantity || 0),
    0
  );
  const totalMinQty = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.min_qty || 0),
    0
  );
  const totalFreightAmt = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.feight_amt || 0),
    0
  );
  const totalshortAmt = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.short_amt || 0),
    0
  );
  const totalshortQty = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.short_qty || 0),
    0
  );
  const totalNetFreightAmt = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.net_feight_amt || 0),
    0
  );
  const totalFuelAmt = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.fuel_amt || 0),
    0
  );
  const totalCashAdvance = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.cash_advance || 0),
    0
  );
  const totalloadingExpenses = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.loading_expenses || 0),
    0
  );
  const totalpenaltyCharges = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.penalty_amount || 0),
    0
  );
  const totalDeductions = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.total_deduction || 0),
    0
  );
  const totalbalanceAmt = printData.challans.reduce(
    (sum, row) => sum + parseFloat(row.balance_amt || 0),
    0
  );

  const netPayable = totalFreightAmt - totalDeductions;
  const numberToWords = num => {
    if (num === 0) return 'Zero';

    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen'
    ];
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety'
    ];

    const convert_hundred = n => {
      let word = '';
      if (n > 99) {
        word += ones[Math.floor(n / 100)] + ' Hundred ';
        n %= 100;
      }
      if (n > 19) {
        word += tens[Math.floor(n / 10)] + ' ';
        n %= 10;
      }
      if (n > 0) {
        word += ones[n] + ' ';
      }
      return word;
    };

    const convert_number = n => {
      let word = '';

      if (n >= 100000) {
        word += convert_hundred(Math.floor(n / 100000)) + 'Lakh ';
        n %= 100000;
      }
      if (n >= 1000) {
        word += convert_hundred(Math.floor(n / 1000)) + 'Thousand ';
        n %= 1000;
      }
      word += convert_hundred(n);
      return word.trim();
    };

    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);

    let result = convert_number(rupees);
    if (paise > 0) {
      result += ' and Paise ' + convert_number(paise);
    }
    return result + ' Only';
  };

  const amount = printData?.totalChallanAmount || 0;
  const amountInWords = numberToWords(amount);
  console.log('🚀 ~ SettlementPrint ~ amount:', amount);

  return (
    <Portal>
      <div
        id="challan"
        style={{ zIndex: '-1', position: 'fixed', top: '0', left: '-100vw' }}
      >
        <Row style={{ maxHeight: 'calc(100vh - 50px)' }}>
          {/* <div className="print-meta">
            <div>
              <strong>Print Date & Time:</strong> {new Date().toLocaleString()}
            </div>
            <div>
              <strong>Page:</strong> <span className="pageNumber"></span>
            </div>
          </div> */}
          <Col xs={12} lg={12} className="rounded-3">
            <div className="bg-white rounded-3 h-100 d-flex flex-column">
              <Modal.Body className="px-4 pb-0">
                <>
                  <div className="container border p-4 mt-3">
                    <div className="text-center">
                      <div style={{ verticalAlign: 'middle' }} width="30%">
                        <img
                          id="logo"
                          src={kerpLogo}
                          style={{
                            width: 455,
                            height: 'auto',
                            display: 'inline'
                          }}
                          alt=""
                        />
                      </div>
                    </div>

                    <div id="container1">
                      <div className="left-content">
                        <p className="paragraph">
                          <strong>To:</strong>{' '}
                          {printData.truckerInformation.truckerName}
                        </p>
                        <p className="paragraph">
                          <strong>Contact:</strong>{' '}
                          {printData.truckerInformation.contactNo}
                        </p>
                        <p className="paragraph">
                          <strong>PAN:</strong>{' '}
                          {printData.truckerInformation.panNo}
                        </p>
                        <p className="paragraph">
                          <strong>A/C No:</strong>{' '}
                          {printData.truckerInformation.bankAccountNo}
                        </p>
                        <p className="paragraph">
                          <strong>IFSC Code:</strong>{' '}
                          {printData.truckerInformation.ifscCode}
                        </p>
                      </div>

                      <div className="right-content">
                        <table className="info-table">
                          <tbody>
                            <tr>
                              <td>
                                <strong>Voucher Date:</strong>
                              </td>
                              <td>
                                {formatDate(
                                  printData.settlement_date,
                                  'DD MMM YY'
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Voucher Status:</strong>
                              </td>
                              <td>
                                {printData?.settlement_status === 'Pending' &&
                                  'On Checking'}
                                {printData?.settlement_status ===
                                  'First_Approved' && 'On Approval'}
                                {printData?.settlement_status ===
                                  'Second_Approved' && 'On Payment'}
                                {printData?.settlement_status ===
                                  'Third_Approved' && 'Paid'}
                                {printData?.settlement_status ===
                                  'First_Rejected' && 'Reject on Check'}
                                {printData?.settlement_status ===
                                  'Second_Rejected' && 'Reject on Approval'}
                                {printData?.settlement_status ===
                                  'Third_Rejected' && 'Cancelled Payment'}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Voucher No / Challan No:</strong>
                              </td>
                              <td>{printData.settelment_no}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Route Name:</strong>
                              </td>
                              <td>
                                {[
                                  ...new Map(
                                    printData.challans?.map(item => [
                                      `${item.from_name}-${item.to_name}`,
                                      item
                                    ])
                                  ).values()
                                ].map((item, index) => (
                                  <div key={`route-${index}`}>
                                    {item.from_name} To {item.to_name}
                                  </div>
                                ))}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Do Number:</strong>
                              </td>
                              <td>
                                {[
                                  ...new Map(
                                    printData.challans?.map(item => [
                                      item.do_number,
                                      item
                                    ])
                                  ).values()
                                ].map((item, index, arr) => (
                                  <colSpan key={`do-${index}`}>
                                    {item.do_number}
                                    {index !== arr.length - 1 && ','}
                                  </colSpan>
                                ))}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Table */}
                    {/* data
                    data */}
                    <Table bordered className="tableMargin">
                      <thead className="thead-bg">
                        <tr className="text-center">
                          <th className="table-heading">Sr.No</th>
                          <th>Challan Date</th>
                          <th>Challan No</th>
                          <th>Vehicle No</th>
                          <th>Rate</th>
                          <th>Dis Qty</th>
                          <th>Rec Qty</th>
                          <th>Min Qty</th>
                          <th>Freight Amt</th>
                          <th>Short Qty</th>
                          <th>Short Amt</th>
                          <th>Net Freight</th>
                          {/* <th>Fuel Ltr</th> */}
                          <th>Fuel Amt</th>
                          <th>Cash Advance</th>
                          <th>Loading Expenses</th>
                          <th>Penalty Charges</th>
                          <th>Total Deductions</th>
                          <th>Balance Amt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {printData.challans.map((row, index) => (
                          <tr key={index} className="text-center">
                            <td>{index + 1}</td>
                            <td>{row.challan_date}</td>
                            <td>{row.challan_no}</td>
                            <td>{row.vehicle_number}</td>
                            <td>{currencyFormat(row.rate)}</td>
                            <td>{row.dispatch_quantity}</td>
                            <td>{row.receive_quantity}</td>
                            <td>{row.min_qty}</td>

                            <td>{currencyFormat(row.feight_amt)}</td>
                            <td>{row.short_qty}</td>
                            <td>{currencyFormat(row.short_amt)}</td>
                            <td>{row.net_feight_amt}</td>
                            {/* <td>{row.fuelLtr}</td> */}
                            <td>{currencyFormat(row.fuel_amt)}</td>
                            <td>{currencyFormat(row.cash_advance)}</td>
                            <td>{currencyFormat(row.loading_expenses)}</td>
                            <td>{currencyFormat(row.penalty_amount)}</td>
                            <td>{currencyFormat(row.total_deduction)}</td>
                            <td>{currencyFormat(row.balance_amt)}</td>
                          </tr>
                        ))}
                        {/* Totals Row */}
                        <tr className="fw-bold text-center bg-light">
                          <td colSpan="5">Total:</td>
                          <td>{totalDisQty.toFixed(2)}</td>
                          <td>{totalRecQty.toFixed(2)}</td>
                          <td>{totalMinQty.toFixed(2)}</td>

                          <td>{currencyFormat(totalFreightAmt.toFixed(2))}</td>

                          <td>{currencyFormat(totalshortQty.toFixed(2))}</td>
                          <td>{totalshortAmt.toFixed(2)}</td>
                          <td>{totalNetFreightAmt.toFixed(2)}</td>
                          <td>{currencyFormat(totalFuelAmt.toFixed(2))}</td>
                          <td>{currencyFormat(totalCashAdvance.toFixed(2))}</td>

                          <td>
                            {currencyFormat(totalloadingExpenses.toFixed(2))}
                          </td>
                          <td>
                            {currencyFormat(totalpenaltyCharges.toFixed(2))}
                          </td>

                          {/* <td colSpan="2"></td> */}
                          <td>{currencyFormat(totalDeductions.toFixed(2))}</td>
                          <td>{currencyFormat(totalbalanceAmt.toFixed(2))}</td>
                        </tr>
                        <tr className="fw-bold text-center bg-light">
                          <td colSpan="5">TDS Charge</td>
                          <td colSpan="12"></td>
                          <td className="text-danger text-nowrap">
                            {currencyFormat(printData?.totalTdsCharges || 0)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                    {/* Net Payable Section */}
                    <div id="amount-container">
                      <div>
                        <p className="bold-text">Rupees in Words: </p>
                        <p className="blue-text">{amountInWords}</p>
                      </div>

                      <h4 className="heading">
                        Net Payable:
                        <span className="netPay">
                          {currencyFormat(printData?.totalChallanAmount)}
                        </span>
                      </h4>
                    </div>

                    {/* Bank Details */}
                    <div className="bank-detail-heading">
                      <p className="bank-detail">Bank Details:</p>
                      <p className="bank-detail-mt">
                        <strong className="bold-sub">Bank & Branch: </strong>
                        <span className="bold-sub-detail">
                          Punjab National Bank
                        </span>
                      </p>
                      <p className="bank-detail-mt">
                        <strong className="bold-sub">A/C No:</strong>{' '}
                        <span className="bold-sub-detail">
                          6114008700000863
                        </span>
                      </p>
                      <p className="bank-detail-mt">
                        <strong className="bold-sub">IFSC Code:</strong>{' '}
                        <span className="bold-sub-detail">PUNB0611400</span>
                      </p>
                    </div>

                    {/* Signatures */}
                    <div id="info-container">
                      <div className="">
                        <p className="bank-detail">Prepared By</p>
                        <p className="bold-sub-detail">
                          {printData.created_by_name}
                        </p>
                      </div>
                      <div className="">
                        <p className="bank-detail">Checked By</p>
                        <p className="bold-sub-detail">
                          {printData.checker_by_name}
                        </p>
                      </div>
                      <div className="">
                        <p className="bank-detail">Approved By</p>
                        <p className="bold-sub-detail">
                          {printData.approved_by_name}
                        </p>
                      </div>

                      <div className="">
                        <p className="bank-detail">Paid By</p>
                        <p className="bold-sub-detail">
                          {printData.paid_by_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <PageLoader
                         loading={loading}
                         loadingMessage={'Fetching Data'}
                       /> */}
                </>
              </Modal.Body>
            </div>
          </Col>
        </Row>
      </div>
    </Portal>
  );
};

export { SettlementPrint };
export default PaymentSettlementPrint;
